import { string2money } from 'common/utils/string';
import DrawerHeader from 'components/common/drawer/drawer-header';
import { DrawerBody } from 'components/common/drawer/styles';
import Text from 'components/elements/text';
import { SeparatorHorizontal, SeparatorVertical } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';

import { TotalContent, TotalItemContent } from './styles';
import SummaryItem from './summary-item';
import useRecalculate from '../../hooks/use-recalculate';
import { TicketSaleFormType } from '../form-type';

interface Props {
  onClose: () => void;
}

function Total({ label, price }: { label: string; price: number }) {
  return (
    <TotalContent>
      <TotalItemContent>
        <Text variant="LabelMedium">{label}:</Text>
        <SeparatorHorizontal $margin={8} />
        <Text variant="HeadingXSmall">{`Rp ${string2money(price)}`}</Text>
      </TotalItemContent>
    </TotalContent>
  );
}

export default function SummaryDrawer(props: Props) {
  const { t } = useTranslation();
  const { onClose } = props;

  const { getValues } = useFormContext<TicketSaleFormType>();
  const { subtotal } = useRecalculate();

  return (
    <>
      <DrawerHeader
        onClose={onClose}
        title={t('ticketSales:flight_sales_details')}
      />
      <DrawerBody>
        {getValues('flightSales').map((schedule, idx) => (
          <React.Fragment key={schedule.customId || idx}>
            <SummaryItem
              key={schedule.customId || idx}
              parentIdx={idx}
              data={schedule}
            />
            <SeparatorVertical $margin={24} />
          </React.Fragment>
        ))}
        <Total label={t('common:subtotal')} price={subtotal} />
        <Total label={t('common:discount')} price={getValues('discount')} />
        <Total label={t('common:other_cost')} price={getValues('otherCost')} />
        <Total label={t('common:total')} price={getValues('total')} />
      </DrawerBody>
    </>
  );
}
